import type { Writable, Readable } from 'svelte/store';
import { writable, derived } from 'svelte/store';
import { devices } from '../lists/devices';
import { devices_settings, devices_status } from '../device-runtime/status';
import { wifi_ssid } from '../session/native-bridge';
import { devices_config } from '@devices/index';

//#region Discovered Stores
export const allDiscovered: Writable<{ [key: string]: any }> = writable({});

export const ongoingDiscovery = writable(false);

// derived stores
// filters in all discovered devices that are not yet added to the account
export const discovered_devices: Readable<{ [key: string]: any }> = derived(
	[allDiscovered, devices],
	([$allDiscovered, $devices]) => {
		return Object.entries($allDiscovered)
			.map(([k, v]) => {
				let item = v;
				item.id = k;
				if (typeof devices_config[v.type] === 'undefined') {
					Object.entries(devices_config).map(([i, e]) => {
						if (e?.name?.toLowerCase() === v?.type?.toLowerCase()) {
							item.type = i;
						}
					});
				}
				return item;
			})
			.sort((a, b) => {
				return (a.type > b.type) as any;
			})
			.reduce((filtered, v) => {
				if (
					typeof devices_config[v.type] !== 'undefined' &&
					Object.keys($devices).indexOf(v.id) < 0
				) {
					filtered[v.id] = v;
				}

				return filtered;
			}, {});
	},
);

export const local_devices: any = !devices
	? {}
	: derived(
			[allDiscovered, devices, devices_status, wifi_ssid],
			([$allDiscovered, $devices, $devices_status, $wifi_ssid]) => {
				const local = {};
				Object.entries($allDiscovered).map((e) => {
					if (typeof $devices[e[0]] !== 'undefined') {
						// if (($devices[e[0]].gen == 2 && $devices_status[e[0]]?.wifi.sta.ssid === $wifi_ssid) || ($devices[e[0]].gen !== 2 && $devices_status[e[0]]?.wifi_sta.ssid === $wifi_ssid)) {
						local[e[0]] = e[1];
						// }
					}
				});

				return local;
			},
		);

//#endregion Discovered Stores
